import React, { useState } from 'react';
import { supabase } from '../config/supabase';

export default function PremiumPlusQuoteForm() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [details, setDetails] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (sending) return;
    setSending(true);
    setError('');
    try {
      const { error: failure } = await supabase.from('quick_callbacks').insert([{
        phone: phone.replace(/\D/g, ''), best_time: 'anytime', source: 'premium_plus_quote',
        notes: `Premium+ individual quote request\nName: ${name.trim()}\nEmail: ${email.trim()}\nProject: ${details.trim()}`,
      }]);
      if (failure) throw failure;
      setSent(true);
    } catch {
      setError('Your request could not be saved. Please try again.');
    } finally {
      setSending(false);
    }
  };

  return <section className="max-w-3xl mx-auto px-6 py-16">
    <h1 className="text-3xl font-bold mb-4">Request a Premium+ Quote</h1>
    <p className="text-gray-600 mb-6">Premium+ is quoted individually. Tell us about your space and we will prepare a proposal with specifications, options and any special site work.</p>
    {sent ? <div role="status" className="rounded-lg bg-green-50 text-green-900 p-6">Your Premium+ request has been received. Our team will contact you to discuss your project.</div> :
      <form onSubmit={submit} className="space-y-5">
        <label className="block">Name<input className="block w-full border rounded p-3 mt-1" value={name} onChange={e => setName(e.target.value)} required maxLength={150} autoComplete="name" /></label>
        <label className="block">Email<input className="block w-full border rounded p-3 mt-1" type="email" value={email} onChange={e => setEmail(e.target.value)} required maxLength={254} autoComplete="email" /></label>
        <label className="block">Phone<input className="block w-full border rounded p-3 mt-1" type="tel" value={phone} onChange={e => setPhone(e.target.value)} required pattern="[0-9 +().-]{8,25}" autoComplete="tel" /></label>
        <label className="block">Project details<textarea className="block w-full border rounded p-3 mt-1" value={details} onChange={e => setDetails(e.target.value)} required maxLength={3000} rows={5} placeholder="Location, approximate size, preferred options and any site requirements" /></label>
        {error && <p role="alert" className="text-red-700">{error}</p>}
        <button className="bg-accent text-white rounded px-6 py-3 disabled:opacity-50" disabled={sending}>{sending ? 'Sending…' : 'Request My Individual Quote'}</button>
      </form>}
    <a className="block mt-6 text-blue-700 underline" href="/pergola-quote">Looking for Premium? Get an instant estimate</a>
  </section>;
}
